import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { validateDateFilter, getCountries } from './helper';
import moment from 'moment';
import MultiSelect from '../MultiSelect/index';
import Select from 'react-select';
import { deleteEntityFilter } from '../../../Analyst/Cases/List/Helper';

const counterpartyType = [{ value: "NORMAL", label: "PORTFOLIO" }, { value: "QUICK", label: "NON PORTFOLIO" }]
const caseTypes = [{ value: "DOMESTIC", label: "INDIAN" }, { value: "INTERNATIONAL", label: "INTERNATIONAL" }]

class FilterFormTypeTwo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toDate: null,
            fromDate: null,
            dateValidateFlag: true,
            selectedEntityData: [],
            errorMsg: '',
            selectedOption: '',
            selectedOptionCase: '',
            selectedOptionStatus: '',
            selectedOptionCountry: ''
        }
    }
    handleFromDateChange = (date) => {
        this.setState({
            fromDate: date
        })
        if (date && this.state.toDate) {
            this.setState({
                dateValidateFlag: false
            })
        }
    }
    handleToDateChange = (date) => {
        this.setState({
            toDate: date
        });
        if (date && this.state.fromDate) {
            this.setState({
                dateValidateFlag: false
            })
        }
    }
    handleApplyFilter = () => {
        const validate = validateDateFilter(this.state.toDate, this.state.fromDate);
        if (validate.validationFlag) {
            this.setState(prevState => ({
                errorMsg: ''
            }))
            let date = {
                toDate: this.state.toDate,
                fromDate: this.state.fromDate
            }
            if(this.props.statusTypeFlag || this.props.countryFlag){
                this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionStatus, this.state.selectedOptionCountry,
                this.state.selectedEntityData, date, true, false);
            }else{
                this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionCase,
                this.state.selectedEntityData, date, true, false);
            }
        } else {
            if (validate.validationMessage) {
                this.setState({
                    errorMsg: validate.validationMessage,
                })
            } else {
                this.setState({
                    toDate: null,
                    fromDate: null
                })
                let date = {
                    toDate: null,
                    fromDate: null
                }
                if(this.props.statusTypeFlag || this.props.countryFlag){
                    this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionStatus, this.state.selectedOptionCountry,
                    this.state.selectedEntityData, date, true, false);
                }else{
                    this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionCase,
                    this.state.selectedEntityData, date, true, false);
                }
            }

        }
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption: selectedOption })
    }

    handleChangeCase = (selectedOptionCase) => {
        this.setState({ selectedOptionCase: selectedOptionCase })
    }

    handleChangeStatus = (selectedOptionStatus) => {
        this.setState({ selectedOptionStatus: selectedOptionStatus })
    }

    handleChangeCountry = (selectedOptionCountry) => {
        this.setState({ selectedOptionCountry: selectedOptionCountry })
    }

    handleResetDateFilter = () => {
        this.setState({
            toDate: null,
            fromDate: null,
            dateValidateFlag: true,
            selectedEntityData: [],
            selectedOption: '',
            selectedOptionCase: '',
            selectedOptionStatus: '',
            selectedOptionCountry: ''
        });
        let date = {
            toDate: null,
            fromDate: null
        }
        if(this.props.countryFlag){
            this.props.filterCallback(null, null, null, [], date, true, true)
        }else{
            this.props.filterCallback(null, null, [], date, true, true)
        }        
    }
    handleRemoveFilter = (removeFilter) => {
        if (removeFilter.value === 'country') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: ''
                })
        }else if (removeFilter.value === 'statusType') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: '',
                selectedOptionCountry: this.state.selectedOptionCountry
                })
        } else if (removeFilter.value === 'caseType') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: '',
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: this.state.selectedOptionCountry
                })
        } else if (removeFilter.value === 'counterpartyType') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: '',
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: this.state.selectedOptionCountry
            })
        } else if (removeFilter.value === 'date') {
            this.setState({
                toDate: null,
                fromDate: null,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: this.state.selectedOptionCountry
            })
        } else {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: deleteEntityFilter(this.state.selectedEntityData, removeFilter),
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,    
                selectedOptionCountry: this.state.selectedOptionCountry            
            })
        }
    }

    handleFilterOnPageRefreshOrBackButton = (urlFilters) => {
        this.setState({
            toDate: urlFilters.toDate ? urlFilters.toDate : null,
            fromDate: urlFilters.fromDate ? urlFilters.fromDate : null,
            dateValidateFlag: true,
            // selectedEntityData: urlFilters.selectedCorporates.length !== 0 ? urlFilters.selectedCorporates : [],
            selectedOption: urlFilters.productType ? urlFilters.productType : '',
            // selectedOptionCase: urlFilters.caseType ? urlFilters.caseType : '',
            // selectedOptionStatus: urlFilters.statusType ? urlFilters.statusType : '',    
            selectedOptionCountry: urlFilters.country ? urlFilters.country : ''            
        })
    }

    hideFilter = () => {
        this.props.hideFilterCallback()
    }
    selectedEntityCallback = (selectedData) => {
        this.setState({
            selectedEntityData: selectedData
        })
    }
    render() {
        return (
            <div>
                <Row className="mb-3 align-items-center">                                                           
                    <Col xs='4'>
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Business Check Date</span>
                    </Col>
                    <Col sm="7">
                        <div className="d-flex align-items-center">
                            <DatePicker className="form-control" selected={(this.state.fromDate!==null) ? (this.state.fromDate) : null} onChange={this.handleFromDateChange} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-YYYY" maxDate={moment()} />
                            <span><i className="icon-minus text-dark"></i></span>
                            <DatePicker className="form-control" selected={(this.state.toDate!==null) ? (this.state.toDate) : null} onChange={this.handleToDateChange} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-YYYY" maxDate={moment()} />
                        </div>
                        <div>
                            <span className="text-danger">{this.state.errorMsg}</span>
                        </div>
                    </Col>
                </Row>
                    {/* <Col sm="11" className="filter-category py-sm-20">
                            <BillingFilter dateFilter={this.dateFilterCallBack} />
                        </Col> */}
                <Row className="mb-3 align-items-center">
                    {this.props.productTypeFlag && <Col xs="4" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Counterparty Type</span>
                    </Col>
                    }
                    {this.props.productTypeFlag && <Col sm={5}>
                        <Select
                            value={this.state.selectedOption}
                            onChange={this.handleChange}
                            options={counterpartyType}
                            isClearable={true} />
                    </Col>
                    }

                    {this.props.caseTypeFlag && <Col xs="3" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Geography</span>
                    </Col>
                    }
                    {this.props.caseTypeFlag && <Col sm={5}>
                        <Select
                            value={this.state.selectedOptionCase}
                            onChange={this.handleChangeCase}
                            options={caseTypes}
                            isClearable={true} />
                    </Col>
                    }
                </Row>
                <div className="d-flex justify-content-between">
                    <div>
                        <Button className="mr-3" outline color="primary" onClick={this.hideFilter}>Hide Filters</Button>
                        <Button outline color="primary" onClick={this.handleResetDateFilter}>Reset Filters</Button>
                    </div>
                    <div>
                        <Button color="primary" onClick={this.handleApplyFilter}>Apply</Button>
                    </div>
                </div>
            </div> 
        )
    }
}
export default FilterFormTypeTwo;